import { auth } from "../firebase/firebaseConfig";
import axios from 'axios'

export const tokenProvider = async () => {
    const user = auth.currentUser;
    console.log(user)
    
    if (user.stsTokenManager.isExpired === true) {
        await axios.post(
            "https://securetoken.googleapis.com/v1/token?key=AIzaSyDoPKrGzJQ37bA07RDUEG7PjBe3M2JE0qw",
            {
                "grant_type": "refresh_token",
                "refresh_token": user.refreshToken
            }
        ).then(({ data }) => {
            console.log("actualizando")
            console.log(data)
            return data.id_token
        })
    } else {
        return user.accessToken
    }
}